import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  useGetAccountMutation,
  useTokenFromSessionMutation,
} from "app/authApi";
import { setSsoStatus } from "features/userSlice";

const useSsoSync = () => {
  const dispatch = useDispatch();
  const [tokenFromSession] = useTokenFromSessionMutation();
  const [getAccount] = useGetAccountMutation();

  const run = useCallback(async () => {
    dispatch(setSsoStatus("checking"));
    try {
      await tokenFromSession().unwrap();
      await getAccount().unwrap();
      dispatch(setSsoStatus("ok"));
      return true;
    } catch (err) {
      dispatch(setSsoStatus("fail"));
      return false;
    }
  }, [dispatch, tokenFromSession, getAccount]);

  return { run };
};

export default useSsoSync;
